import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { listMaidApplications } from '../../api/admin';
import { Layout } from '../../components/layout/Layout';
import { Spinner } from '../../components/ui/Spinner';

function StatCard({ label, value, to }: { label: string; value: number | string; to: string }) {
  return (
    <Link to={to} className="card hover:shadow-md transition-shadow text-center">
      <p className="text-3xl font-bold text-brand-700">{value}</p>
      <p className="text-sm text-gray-500 mt-1">{label}</p>
    </Link>
  );
}

export function AdminDashboard() {
  const { data: newApplications = [], isLoading } = useQuery({
    queryKey: ['maidApplications', 'new'],
    queryFn:  () => listMaidApplications({ status: 'new' }),
  });

  return (
    <Layout>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Admin Dashboard</h1>
        <p className="text-gray-500 mb-8">Review maid applications and estimator usage.</p>

        {isLoading
          ? <div className="flex justify-center py-16"><Spinner /></div>
          : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <StatCard label="Pending Applications" value={newApplications.length} to="/admin/maids" />
            </div>
          )
        }

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Link to="/admin/maids" className="card hover:shadow-md transition-shadow">
            <div className="text-2xl mb-2">🧹</div>
            <h2 className="font-semibold text-gray-900">Maid Applications</h2>
            <p className="text-sm text-gray-500 mt-1">Review and approve/reject maid applications.</p>
          </Link>
          <Link to="/admin/estimator" className="card hover:shadow-md transition-shadow">
            <div className="text-2xl mb-2">✨</div>
            <h2 className="font-semibold text-gray-900">Estimator Usage</h2>
            <p className="text-sm text-gray-500 mt-1">View all customer AI estimates, photos, and AI responses.</p>
          </Link>
        </div>
      </div>
    </Layout>
  );
}
